import type from './action-type';
import * as api from 'api/api';

export const setHotWordList = payload => {
  return {
    type: type.SET_HOT_WORD_LIST,
    payload
  };
};

export const fetchHotWordList = () => {
  return async f => {
    try {
      const { list } = await api.hotWordList({
        pageSize: 17,
        pageNum: 1
      });

      f(setHotWordList(list));
    } catch (error) {}
  };
};
